import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    customBlue: {
      50: '#E6F4FD',
      100: '#BFE6FB',
      200: '#99D8F9',
      300: '#72CAF7',
      400: '#4CBDF5',
      500: '#09AFF4', // Main color
      600: '#0789C3',
      700: '#056392',
      800: '#043C62',
      900: '#021631',
    },
    customDarkBlue: {
      50: '#E0F2FF',
      100: '#B3E0FF',
      200: '#80C8FF',
      300: '#4DAFFF',
      400: '#1A97FF',
      500: '#007FFF', // Main color
      600: '#0066CC',
      700: '#0052A3',
      800: '#003D7A',
      900: '#002852',
    },
    fonts: {
      heading: `'Pacifico', cursive`,
      body: `'Quicksand', sans-serif`,
    },
  },
  components: {
    Button: {
      variants: {
        gradient: {
          bgGradient: 'linear(to-r, #ffd340, #ff923c)',
          color: 'white',
          borderRadius: '3rem',
          _hover: {
            boxShadow: '0 0.5em 0.5em -0.4em #ff923cba',
            transform: 'translateY(-0.15em)',
          },
        },
      },
    },
  },
});

export default theme;